import React from 'react';

export default function Line(props) {
  return (
    <svg width={props.width} x={props.x} y={props.y} height="1px" viewBox={`0 0 ${props.width} 1`} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <desc>Created with Sketch.</desc>
      <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd" strokeDasharray={4}>
        <g id="y-axis" transform="translate(0.000000, -52.000000)" fill="#C9CED6" stroke="#9FA6B1">
          <line x1={0} y1="52.5" x2={props.width} y2="52.5" id="Line-Copy" />
        </g>
      </g>
    </svg>
  );
}
